import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BirthDateAutoInputFields',
  props: {
    year: null,
    month: null,
    day: null,
    errorMessage: null
  },
  emits: ["update:year", "update:month", "update:day"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:year', value: string | number): void
  (e: 'update:month', value: string | number): void
  (e: 'update:day', value: string | number): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})